export const libraries = [
  {
    // https://github.com/openscad/MCAD
    name: 'MCAD',
    description: 'A library for OpenSCAD that includes a number of utilities.',
    url: `${import.meta.env.BASE_URL}/libraries/MCAD.zip`,
  },
  {
    // https://github.com/BelfrySCAD/BOSL2/
    name: 'BOSL2',
    description: 'A library for OpenSCAD that includes a number of utilities.',
    url: `${import.meta.env.BASE_URL}/libraries/BOSL2.zip`,
  },
  {
    // https://github.com/revarbat/BOSL
    name: 'BOSL',
    description: 'A library for OpenSCAD that includes a number of utilities.',
    url: `${import.meta.env.BASE_URL}/libraries/BOSL.zip`,
  },
  {
    // https://github.com/cfinke/LEGO.scad
    name: 'LEGO',
    description: 'An OpenSCAD library for generating LEGO bricks.',
    url: `${import.meta.env.BASE_URL}/libraries/LEGO.zip`,
  },
  {
    // https://github.com/kennetek/gridfinity-rebuilt-openscad
    name: 'gridfinity',
    displayName: 'Gridfinity',
    description:
      'Parametric Gridfinity storage system bins and baseplates, rebuilt in OpenSCAD.',
    url: `${import.meta.env.BASE_URL}/libraries/gridfinity.zip`,
  },
];
